module.exports = __webpack_public_path__ + "static/img/banner1_en.32a1958.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/banner1_en.png
// module id = nvMV
// module chunks = 1